let sampleWrappers = document.querySelectorAll('.sample__wrapper');
let chosedSamples = {};
let imageSwiper = null;
document.addEventListener('DOMContentLoaded', function () {
imageSwiper = new Swiper(".section-samples__swiper", {
    slidesPerView: "auto",
    spaceBetween: 8,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
});
})

function handleSampleWrapperClick(event) {
    var dataId = event.currentTarget.getAttribute('data-id');
    var imgSrc = event.currentTarget.querySelector('img').getAttribute('src');
    var sampleObject = sampleObjects.find(function (sample) {
        return sample.id === parseInt(dataId);
    });

    if (event.currentTarget.classList.contains('added')) {
        event.currentTarget.classList.remove('added');
        delete chosedSamples[dataId];

        var orderedImages = document.querySelectorAll('.section-samples__ordered img');
        orderedImages.forEach(function (image) {
            if (image.getAttribute('data-id') === dataId) {
                image.remove();
            }
        });
    } else {
        event.currentTarget.classList.add('added');

        chosedSamples[dataId] = {
            sampleObject: sampleObject,
            imgSrc: imgSrc
        };

        var orderedImage = document.createElement('img');
        orderedImage.src = imgSrc;
        orderedImage.classList.add('chosen_img');
        orderedImage.setAttribute('data-id', dataId);
        document.querySelector('.images-list__chosen').appendChild(orderedImage);
    }
    updateTotalPrice();
    updateAddButtonState();
}

sampleWrappers.forEach(function (wrapper) {
    wrapper.addEventListener('click', handleSampleWrapperClick);
});
let addButton = document.querySelector('.ordered-footer__add-button');
let totalPriceElement = document.querySelector('.total-wrapper__price');

function updateAddButtonState() {
    var quantityElement = document.querySelector('.ordered-heading__quantity');
    var quantity = Object.keys(chosedSamples).length;

    if (quantity === 0) {
        addButton.setAttribute('disabled', 'disabled');
    } else {
        addButton.removeAttribute('disabled');
    }

    quantityElement.textContent = quantity + selectedText;
    let emptyDivs = document.querySelectorAll('.images-list__empty, .images-list__empty-image');
      if (quantity > 0) {
        emptyDivs.forEach(function (emptyDiv) {
            emptyDiv.style.display = 'none';
        });
    } else{
        emptyDivs.forEach(function (emptyDiv) {
            emptyDiv.style.display = 'block';
        });
    }
}

function updateTotalPrice() {
    let totalPrice = 0;
    for (let dataId in chosedSamples) {
        totalPrice += chosedSamples[dataId].sampleObject.price;
    }
    totalPriceElement.textContent = `€${(totalPrice / 100).toFixed(2)}`;
}
updateAddButtonState();

function updateCartDrawer() {
    const drawer = document.querySelector('cart-drawer')
    if(!drawer) return
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
    drawer.setAttribute('open', '')
}

addButton.addEventListener('click', function () {
    let items = [];

    for (var dataId in chosedSamples) {
        items.push({
            'id': parseInt(dataId),
            'quantity': 1,
            'sampleObject': chosedSamples[dataId].sampleObject
        });
    }

    let formData = {
        'items': items
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            return response.json();
        })
        .then(data => {
            const event = new CustomEvent('itemsAddedToCart', {
                type: 'cart:change',
                bubbles: true,
                cancelable: true,
                detail: {
                    addedItems: items
                }
            });
            console.log(1);
            document.dispatchEvent(event);
            chosedSamples = {};

            addButton.setAttribute('disabled', 'disabled');

            let chosenImages = document.querySelectorAll('.images-list__chosen img');
            chosenImages.forEach(function (image) {
                image.remove();
            });

            let sampleWrappers = document.querySelectorAll('.sample__wrapper');
            sampleWrappers.forEach(function (wrapper) {
                wrapper.classList.remove('added');
            });
            updateTotalPrice();
            updateAddButtonState();
            updateCartDrawer()
        })

        .catch((error) => {
            console.error('[ERROR]:', error);
        });
});

